module.exports = __webpack_public_path__ + "static/media/logo.1e6574f1.png";